export default "__VITE_ASSET__1Tq$mTGj__"